/*  ========================================================================
    # Components - Post Card
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';
import LazyImage from './LazyImage';

const PostCard = ({ skeleton, image, title, date, author, excerpt, url, linkText }) => {
  const lang = document.documentElement.lang;
  const convertedDate = new Date(date).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Icons
  const local = useLocalization();
  const iconImage = `${local('svgSprite')}#image`;

  return (
    <>
      {skeleton ? (
        <div className='c-post-card c-post-card--skeleton'>
          <div className='c-post-card__image' />
          <h3 className='c-post-card__title' />
          <span className='c-post-card__date' />
          <p className='c-post-card__excerpt' />
          <div className='c-post-card__link' />
        </div>
      ) : (
        <div className='c-post-card'>
          <a href={url} aria-label={title} tabIndex={-1}>
            {image && !(image instanceof Array && image.length < 1) ? (
              <LazyImage
                defaultUrl={image.medium_large}
                placeholderUrl={image.placeholder}
                figureClass='c-post-card__image'
                alt={title}
              ></LazyImage>
            ) : (
              <figure className='c-post-card__image c-post-card__image--placeholder'>
                <svg>
                  <use href={iconImage}></use>
                </svg>
              </figure>
            )}
          </a>
          <h3 className='c-post-card__title' dangerouslySetInnerHTML={{ __html: title }} />
          {(date || author) && (
            <span className='c-post-card__date'>
              {date && convertedDate} {author && `· ${author}`}
            </span>
          )}
          <p className='c-post-card__excerpt' dangerouslySetInnerHTML={{ __html: excerpt }} />
          <a href={url} aria-label={title} className='c-link-with-svg c-link-with-svg--arrow'>
            {linkText}
          </a>
        </div>
      )}
    </>
  );
};

PostCard.propTypes = {
  skeleton: PropTypes.bool,
  post: PropTypes.object,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.any]),
  title: PropTypes.string,
  date: PropTypes.string,
  author: PropTypes.string,
  excerpt: PropTypes.string,
  url: PropTypes.string,
  linkText: PropTypes.string
};

export default PostCard;
